///<reference path="../../../../node_modules/@angular/core/src/metadata/directives.d.ts"/>
import {Component, OnInit} from '@angular/core';
import 'rxjs/add/operator/filter';
import {EnumModel} from '../../models/enum.model';
import {CalcRequestModel} from '../../models/calc-request.model';
import {CalcApiService} from '../../services/calc-api.service';
import {CalcResponseModel} from '../../models/calc-response.model';
import {StorageHelperService} from '../../services/storage-helper.service';
import {Router} from '@angular/router';
import {FormBuilder, FormGroup} from '@angular/forms';
import {environment} from '../../../environments/environment.dev';
import {isUndefined} from 'util';
import {FileURL} from '../../models/FileURL.model';
import {DatumiHelper} from '../../helpers/datum.helper';
import { UserResponseModel } from '../../models/user-response.model';


@Component({
  selector: 'app-this',
  templateUrl: './TarrifCalc.component.html',
  styleUrls: ['./TarrifCalc.component.less']
})
export class TarrifCalcJednokratnoComponent implements OnInit {

  Resultsmodal = false;
  currentYear: number;
  Meseci: EnumModel[] = [];

  // Age combo
  showAgeDrop = false;
  disableAgeCombo = false;
  insuranceAge: EnumModel = new EnumModel(null, '');
  ageSource: EnumModel[] = [];
  ageErrorMessage = '';


  // duration combo
  showDurationDrop = false;
  disableDurationCombo = false;
  insuranceDuration: EnumModel = new EnumModel(null, '');
  durationSource: EnumModel[] = [];
  durationErrorMessage = '';

  // Payment combo
  showPaymenteDrop = false;
  disablePaymentCombo = false;
  insurancePayment: EnumModel = new EnumModel(null, '');
  PaymentSource: EnumModel[] = [];
  PaymentErrorMessage = '';


  // v1
  showv1Drop = false;
  disablev1Combo = false;
  insurancev1: EnumModel = new EnumModel(null, '');
  v1Source: EnumModel[] = [];
  v1ErrorMessage = '';

  // v2
  showv2Drop = false;
  disablev2Combo = false;
  insurancev2: EnumModel = new EnumModel(null, '');
  v2Source: EnumModel[] = [];
  v2ErrorMessage = '';

  // v3
  showv3Drop = false;
  disablev3Combo = false;
  insurancev3: EnumModel = new EnumModel(null, '');
  v3Source: EnumModel[] = [];
  v3ErrorMessage = '';

  // v4
  showv4Drop = false;
  disablev4Combo = false;
  insurancev4: EnumModel = new EnumModel(null, '');
  v4Source: EnumModel[] = [];
  v4ErrorMessage = '';

  // v5
  showv5Drop = false;
  disablev5Combo = false;
  insurancev5: EnumModel = new EnumModel(null, '');
  v5Source: EnumModel[] = [];
  v5ErrorMessage = '';

  // v6
  showv6Drop = false;
  disablev6Combo = false;
  insurancev6: EnumModel = new EnumModel(null, '');
  v6Source: EnumModel[] = [];
  v6ErrorMessage = '';


  // Gender combo
  showGenderDrop = false;
  disableGenderCombo = false;
  insuranceGender: EnumModel = new EnumModel(null, '');
  GenderSource: EnumModel[] = [];
  GenderErrorMessage = '';

  // option
  PrToVs = true;

  VsToPr = false;

  calcRequestModel: CalcRequestModel = new CalcRequestModel();
  fileURL: FileURL = new FileURL();
  loader = false;
  calcRequestModelForm: CalcRequestModel = new CalcRequestModel();
  calcResponseModel: CalcResponseModel = new CalcResponseModel();
  userForm: FormGroup;

  type: string;

  private currentUser: string = 'currentUser';
  private user: UserResponseModel = new UserResponseModel();


  constructor(private webShopApiService: CalcApiService, private router: Router, private fb: FormBuilder) {

    this.userForm = fb.group({
      'OValue': [null],
      'RDZValue': [null],
    });

    this.PaymentSource.push(new EnumModel(0, 'Годишно плаќање'));
    this.PaymentSource.push(new EnumModel(1, 'Полугодишно плаќање'));
    this.PaymentSource.push(new EnumModel(2, 'Тримесечно плаќање'));
    this.PaymentSource.push(new EnumModel(3, 'Месечно плаќање'));

    this.insurancePayment = new EnumModel(0, 'Годишно плаќање');


    this.calcRequestModel = StorageHelperService.GetData('CalcRequestModel');
    if (!this.calcRequestModel) {
      //  this.router.navigate(['home']);
    }

  }

  ngOnInit() {

    this.retrieveCurrentUser();

    if (this.calcRequestModel == null) {
      this.router.navigate(['TarrifChoos'], {queryParams: {type: this.type}, queryParamsHandling: 'merge'});
    }

    this.currentYear = DatumiHelper.racunajgodinu(false);


    sessionStorage.clear();
    this.initAge();
    this.initGender();
    this.initv1();
    this.initv2();
    this.initv3();
    this.initv4();
    this.initv5();
    this.initv6();

    this.calcRequestModel.VrstaIzracuna = 0;

  }

  public retrieveCurrentUser() {

    const storedUser: string = localStorage.getItem(this.currentUser);
    if (!storedUser) { throw new Error('no user found'); }


    try {
      this.user = JSON.parse(storedUser);
    } catch (err) {
      console.error(err);
    }
    return this.user;
  }

  changedurationByAge() {
    if (this.calcRequestModel.Tarifa === 36) {
      this.durationSource = [];

      const Age = this.currentYear - this.insuranceAge.id;
      const AgeReCalc = 25 - Age;
      if (Age === 0) {
        for (let i = 6; i <= 25; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      } else if (Age >= 1 && Age <= 14) {
        for (let i = 6; i <= AgeReCalc; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      }
    } else if (this.calcRequestModel.Tarifa === 12) {
      this.durationSource = [];

      const Age = this.currentYear - this.insuranceAge.id;
      const AgeReCalc = 75 - Age;
      if (Age >= 15 && Age <= 50) {
        for (let i = 5; i <= 25; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      } else if (Age >= 51 && Age <= 65) {
        for (let i = 5; i <= AgeReCalc; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      }
    }else if (this.calcRequestModel.Tarifa === 310) {
      this.durationSource = [];

      const Age = this.currentYear - this.insuranceAge.id;
    //  const AgeReCalc = 75 - Age;
      if (Age >= 15 && Age <= 35) {
        for (let i = 5; i <= 14; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      } else if (Age >= 36 && Age <= 65) {
        for (let i = 5; i <= 14; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      }
    }else if (this.calcRequestModel.Tarifa === 32) {
      this.durationSource = [];

      const Age = this.currentYear - this.insuranceAge.id;
      const AgeReCalc = 79 - Age;
    //  const AgeReCalc = 75 - Age;
      if (Age >= 15 && Age <= 55) {
        for (let i = 3; i <= 25; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      } else if (Age >= 56 && Age <= 65) {
        for (let i = 3; i <= AgeReCalc; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      }
    }
     else {
      this.durationSource = [];

      const Age = this.currentYear - this.insuranceAge.id;
      const AgeReCalc = 75 - Age;
      if (Age >= 15 && Age <= 35) {
        for (let i = 3; i <= 40; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      } else if (Age >= 36 && Age <= 65) {
        for (let i = 3; i <= AgeReCalc; i++) {
          this.durationSource.push(new EnumModel(i, String(i)));
        }
      }
    }


  }

  selectInsuranceDuration(duration: EnumModel) {
    this.durationErrorMessage = '';
    this.insuranceDuration = duration;
    this.showDurationDrop = false;
  }

  onClickOutsideDurationCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showDurationDrop = false;
    }
  }

  durationComboEvent() {
    if (!this.disableDurationCombo) {
      this.showDurationDrop = !this.showDurationDrop;
    }
  }

  initAge() {
    if (this.calcRequestModel.Tarifa === 36) {
      const AgeFrom = this.currentYear - 14;
      const AgeTo = this.currentYear;
      for (let i = AgeFrom; i <= AgeTo; i++) {
        this.ageSource.push(new EnumModel(i, String(i)));
      }


      this.insuranceAge = new EnumModel(AgeFrom, String(AgeFrom));
      this.changedurationByAge();
      this.insuranceDuration = new EnumModel(3, String(3));

    } else {
      const AgeFrom = this.currentYear - 65;
      const AgeTo = this.currentYear - 15;
      for (let i = AgeFrom; i <= AgeTo; i++) {
        this.ageSource.push(new EnumModel(i, String(i)));
      }


      this.insuranceAge = new EnumModel(AgeFrom, String(AgeFrom));
      this.changedurationByAge();

      if (this.calcRequestModel.Tarifa === 12 || this.calcRequestModel.Tarifa === 310) {
        this.insuranceDuration = new EnumModel(5, String(5));
      }
      else{
      this.insuranceDuration = new EnumModel(3, String(3));
      }

    }
  }


  selectInsuranceAge(duration: EnumModel) {
    this.ageErrorMessage = '';
    this.insuranceAge = duration;
    this.showAgeDrop = false;
  }

  onClickOutsideAgeCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showAgeDrop = false;
    }
  }

  AgeComboEvent() {
    if (!this.disableDurationCombo) {
      this.showAgeDrop = !this.showAgeDrop;
    }
  }


  selectInsurancePayment(duration: EnumModel) {
    this.PaymentErrorMessage = '';
    this.insurancePayment = duration;
    this.showPaymenteDrop = false;
  }

  onClickOutsidePaymentCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showPaymenteDrop = false;
    }
  }

  PaymentComboEvent() {
    if (!this.disablePaymentCombo) {
      this.showPaymenteDrop = !this.showPaymenteDrop;
    }
  }

  // Variants
// Variant 1

  initv1() {
    this.v1Source.push(new EnumModel(0, String('Без УИ')));
    this.v1Source.push(new EnumModel(1, String('УИ 1')));
    this.v1Source.push(new EnumModel(2, String('УИ 2')));
    this.v1Source.push(new EnumModel(3, String('УИ 3')));
    this.v1Source.push(new EnumModel(4, String('УИ 4')));
    this.v1Source.push(new EnumModel(5, String('УИ 5')));
    this.v1Source.push(new EnumModel(6, String('УИ 6')));

    this.insurancev1 = new EnumModel(0, String('Без УИ'));
  }

  selectInsurancev1(duration: EnumModel) {
    this.v1ErrorMessage = '';
    this.insurancev1 = duration;
    this.showv1Drop = false;
    // if (this.insurancev1.id > 0) {
    // this.disablev2Combo = true; } else {this.disablev2Combo = false; }
  }

  onClickOutsidev1Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv1Drop = false;
    }
  }

  v1ComboEvent() {
    if (!this.disablev1Combo) {
      this.showv1Drop = !this.showv1Drop;
    }
  }


  // Variant 2

  initv2() {
    this.v2Source.push(new EnumModel(0, String('Не')));
    this.v2Source.push(new EnumModel(1, String('Да')));

    this.insurancev2 = new EnumModel(0, String('Не'));

  }

  selectInsurancev2(duration: EnumModel) {
    this.v2ErrorMessage = '';
    this.insurancev2 = duration;
    this.showv2Drop = false;
    // if (this.insurancev2.id > 0) {
    //   this.disablev1Combo = true; } else {this.disablev1Combo = false; }
  }

  onClickOutsidev2Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv2Drop = false;
    }
  }

  v2ComboEvent() {
    if (!this.disablev2Combo) {
      this.showv2Drop = !this.showv2Drop;
    }
  }

  // Variant 3

  initv3() {
    this.v3Source.push(new EnumModel(0, String(0)));
    this.v3Source.push(new EnumModel(5, String(5)));
    this.v3Source.push(new EnumModel(10, String(10)));
    this.v3Source.push(new EnumModel(20, String(20)));

    this.insurancev3 = new EnumModel(0, String(0));
  }

  selectInsurancev3(duration: EnumModel) {
    this.v3ErrorMessage = '';
    this.insurancev3 = duration;
    this.showv3Drop = false;
    if (this.insurancev3.id > 0) {
      this.disablev4Combo = true;
    } else {
      this.disablev4Combo = false;
    }
  }

  onClickOutsidev3Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv3Drop = false;
    }
  }

  v3ComboEvent() {
    if (!this.disablev3Combo) {
      this.showv3Drop = !this.showv3Drop;
    }
  }

  // Variant 4

  initv4() {
    this.v4Source.push(new EnumModel(0, String(0)));
    this.v4Source.push(new EnumModel(5, String(5)));
    this.v4Source.push(new EnumModel(10, String(10)));
    this.v4Source.push(new EnumModel(20, String(20)));

    this.insurancev4 = new EnumModel(0, String(0));
  }

  selectInsurancev4(duration: EnumModel) {
    this.v4ErrorMessage = '';
    this.insurancev4 = duration;
    this.showv4Drop = false;
    if (this.insurancev4.id > 0) {
      this.disablev3Combo = true;
    } else {
      this.disablev3Combo = false;
    }
  }

  onClickOutsidev4Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv4Drop = false;
    }
  }

  v4ComboEvent() {
    if (!this.disablev4Combo) {
      this.showv4Drop = !this.showv4Drop;
    }
  }

  // Variant 5

  initv5() {
    this.v5Source.push(new EnumModel(0, String('Female')));
    this.v5Source.push(new EnumModel(1, String('Male')));


    this.insurancev5 = new EnumModel(1, String('Male'));
  }

  selectInsurancev5(duration: EnumModel) {
    this.v5ErrorMessage = '';
    this.insurancev5 = duration;
    this.showv5Drop = false;
  }

  onClickOutsidev5Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv5Drop = false;
    }
  }

  v5ComboEvent() {
    if (!this.disablev5Combo) {
      this.showv5Drop = !this.showv5Drop;
    }
  }

// ﻿// Variant 6

  initv6() {
    this.Meseci = DatumiHelper.listameseci(false);
    this.v6Source = this.Meseci;
    this.insurancev6 = this.v6Source[0];
  }

  selectInsurancev6(duration: EnumModel) {
    this.v6ErrorMessage = '';
    this.insurancev6 = duration;
    this.showv6Drop = false;
  }

  onClickOutsidev6Combo(event: Object) {
    if (event && event['value'] === true) {
      this.showv6Drop = false;
    }
  }

  v6ComboEvent() {
    if (!this.disablev6Combo) {
      this.showv6Drop = !this.showv6Drop;
    }
  }

  // Gender

  initGender() {
    this.GenderSource.push(new EnumModel(0, String('Женско')));
    this.GenderSource.push(new EnumModel(1, String('Машко')));


    this.insuranceGender = new EnumModel(1, String('Машко'));
  }

  selectInsuranceGender(duration: EnumModel) {
    this.GenderErrorMessage = '';
    this.insuranceGender = duration;
    this.showGenderDrop = false;
  }

  onClickOutsideGenderCombo(event: Object) {
    if (event && event['value'] === true) {
      this.showGenderDrop = false;
    }
  }

  GenderComboEvent() {
    if (!this.disableGenderCombo) {
      this.showGenderDrop = !this.showGenderDrop;
    }
  }


  togglePrVS() {
    // this.errorMessage = '';
    this.PrToVs = !this.PrToVs;
    this.VsToPr = false;
    this.calcRequestModel.VrstaIzracuna = 0;
  }

  toggleVsPr() {

    this.VsToPr = !this.VsToPr;
    this.PrToVs = false;
    this.calcRequestModel.VrstaIzracuna = 1;
  }


  submitCalc() {
    this.loader = true;
    this.calcRequestModel.DatumPocetka = DatumiHelper.racunajdatum(false, this.insurancev6.id);
    this.calcRequestModel.IndexUkljucen = 0;
    // this.calcRequestModel.OptimizeTarget =  this.PrToVs = true ? 2 : 1;
    this.calcRequestModel.Iznos = this.userForm.controls['OValue'].value;
    this.calcRequestModel.RDZOsiguranaSuma = this.userForm.controls['RDZValue'].value == null ?
      0 : this.userForm.controls['RDZValue'].value;

      this.calcRequestModel.UserId =this.user.userId;

    this.calcRequestModel.NacinPlacanja = this.insurancePayment.id;
    this.calcRequestModel.Trajanje = this.insuranceDuration.id;
    this.calcRequestModel.Pol = this.insuranceGender.id;
    this.calcRequestModel.Godiste = this.insuranceAge.id;
    this.calcRequestModel.UI = this.insurancev1.id;
    this.calcRequestModel.AUZUkljucen = this.insurancev2.id;
    this.webShopApiService.calculate(this.calcRequestModel)
      .subscribe(
        (response) => {
          this.calcResponseModel = new CalcResponseModel();
          this.calcResponseModel = response;
          this.loader = false;
        },
        (error) => {
          console.log(error);
          this.loader = false;
        }
      );
    window.scroll(0, 0);
    this.Resultsmodal = true;
  }


  downloadInfoPdf() {
    this.loader = true;
    this.webShopApiService.downloadpdf(this.calcResponseModel)
      .subscribe(
        (response) => {
          this.fileURL = response;
          // const fileUrl = response;
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.setAttribute('target', '_blank');
          a.href = this.fileURL.fileURL;
          a.download = '';
          a.click();
          a.remove();
          this.loader = false;
        },
        (error) => {
          this.loader = false;
        }
      );
  }

  downloadInfoPdfFinalOffer() {
    this.loader = true;
    this.webShopApiService.downloadpdfoffer(this.calcResponseModel)
      .subscribe(
        (response) => {
          this.fileURL = response;
          // const fileUrl = response;
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.setAttribute('target', '_blank');
          a.href = this.fileURL.fileURL;
          a.download = '';
          a.click();
          a.remove();
          this.loader = false;
        },
        (error) => {
          this.loader = false;
        }
      );

  }

  downloadGTC() {
    this.loader = true;
    // this.webShopApiService.downloadpdfconditions(this.calcResponseModel)
    //   .subscribe(
    //     (response) => {
     //     this.fileURL = "https://www.grawe.mk/uslovi-za-osiguruva%D1%9Ae/";
          // const fileUrl = response;
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.setAttribute('target', '_blank');
          a.href = "https://www.grawe.mk/uslovi-za-osiguruva%D1%9Ae/";
          a.download = '';
          a.click();
          a.remove();
          this.loader = false;
      //   },
      //   (error) => {
      //     this.loader = false;
      //   }
      // );
  }

  downloadInformacijeLicniPodaci()
  {
    this.loader = true;
    this.webShopApiService.downloadpdfconditions(this.calcResponseModel)
      .subscribe(
        (response) => {
          //this.fileURL = response;
          // const fileUrl = response;
          const a = document.createElement('a');
          document.body.appendChild(a);
          a.setAttribute('style', 'display: none');
          a.setAttribute('target', '_blank');
          a.href = 'https://webshop.grawe.rs/api/files/uslovi/Informacije%20o%20obradi%20licnih%20podataka.pdf';
          a.download = '';
          a.click();
          a.remove();
          this.loader = false;
        },
        (error) => {
          this.loader = false;
        }
      );
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/TarrifCalcJednokratno/TarrifCalc.component.ts